import React from "react";

const Ayuda = () => {
  return <div>Ayuda</div>;
};

export default Ayuda;
